import { usePathname, useRouter, useSearchParams } from 'next/navigation.js';
import { type ActiveReviewParams } from '../types.ts';

export const useActiveReviewDrawerParams = (): [
  ActiveReviewParams | undefined,
  (params: ActiveReviewParams | undefined) => void,
] => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const reviewId = searchParams.get('reviewId');
  const params = reviewId ? { id: reviewId } : undefined;

  const setParams = (newParams: ActiveReviewParams | undefined) => {
    const newSearchParams = new URLSearchParams(searchParams.toString());

    if (newParams) {
      newSearchParams.append('reviewId', String(newParams.id));
    } else {
      newSearchParams.delete('reviewId');
    }

    if (newSearchParams.size > 0) {
      router.push(`${pathname}?${newSearchParams.toString()}`, { scroll: false });
    } else {
      router.push(pathname, { scroll: false });
    }
  };

  return [params, setParams];
};
